module.exports = __webpack_public_path__ + "img/brands.96fe5413.png";